<template>
  <div class="lay-out">
    <!-- <div class="show-menu" @click="showAside">
      <i :class="elIcon"></i>
    </div> -->
    <el-menu
      class="el-menu-vertical-demo"
      :collapse="doneTodos"
      background-color="#1E3A6B"
      text-color="#fff"
      active-text-color="#5686e7"
      :unique-opened="true"
      @select="addTab"
      router
      :default-active="$route.path"
    >
      <el-submenu
        v-for="(val, indx) of funcTreeList"
        :key="indx"
        :index="val.name+''"
      >
        <template slot="title">      
          <i :class="val.meta.icon" class="iconfont"></i>
          <span slot="title">{{ val.meta.title }}</span>
        </template>
        <el-menu-item
          v-for="(item, index) of val.children"
          :key="index"
          :index="'/' + item.path"
          :route="item.path"
        >
          {{ item.meta.title }}
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getmenusList } from '@/api/login'
import { logout } from '@/api/login'
export default {
  data() {
    return {
      // doneTodos: false,
      funcTreeList: [],
      elIcon:"el-icon-d-arrow-left"
    };
  },
  created() {},
  mounted() {
    let str =localStorage.getItem('token')
    let path  = window.location.pathname
    getmenusList().then(res => {
      if(res.code == 200){
      //   if(res.data){
          this.funcTreeList = JSON.parse(JSON.stringify(res.data))
      }
    })
  },
  methods: {
    addTab(key) {
    },
  },
  computed: {
    ...mapGetters(['doneTodos'])
  }
};
</script>
<style scoped lang="scss">
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.lay-out{
  scrollbar-width: none;//firefox隐藏滚动条
  .show-menu{
    position: fixed;
    left: 200px;
    top:100px;
    background: #ff0;
    z-index: 10;
  }
}
.lay-out::-webkit-scrollbar {width: 0};//chrome 隐藏滚动条
.show-menu{
  height: 60px;
  &:hover{
    background: #132A55;
  }
    i{
    font-size: 18px;
    color:#fff;
    float: right;
    padding: 5px 27px 20px 0px;
  }
}
.iconfont{
  color:#fff;
  padding-right: 10px;
}
</style>
